<template>
  <div>
    <vs-card class="mb-4">
      <div class="vx-row p-5">
        <div class="vx-col w-full px-8">
          <div class="flex justify-between gap-2">
            <!-- <div class="flex gap-3 mt-4 w-1/2 items-center">
              <div class="task_card p-3 text-center w-full">
                <h4 class="font-semibold">{{ total_impressions }}</h4>
                <p class="fn13">Total Impressions</p>
              </div>
              <div class="task_card p-3 text-center w-full">
                <h4 class="font-semibold">{{ total_streams }}</h4>
                <p class="fn13">Total Streams</p>
              </div>
            </div> -->
            <div class="vx-row input-group">
              <label>&nbsp;</label>
              <flat-pickr v-model="dateRange" :config="datePickerConfig" placeholder="Select Date" class="w-full" id="dateRange" name="dateRange" />
              <feather-icon v-if="dateRange" icon="XIcon" svgClasses="h-6 w-6 text-danger" data-clear v-tooltip="'Clear'" @click="clearDateRange" />
            </div>
          </div>
        </div>
      </div>
    </vs-card>
    <div>
      <vs-table
        id="creator-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Thumbnail</vs-th>
          <vs-th sort-key="title">Title</vs-th>
          <vs-th sort-key="audio">Audio</vs-th>
          <vs-th sort-key="total_impression">Total Impression</vs-th>
          <vs-th sort-key="total_stream">Total Stream</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              <img :src="tr.audio_details.thumbnail" class="object-cover" height="85px" width="85px" :alt="tr.audio_details.title" />
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.audio_details.title || '-' }} </span>
            </vs-td>
            <vs-td class="text-left">
              <audio ref="audios" :src="tr.audio_details.audio" controls @play="handlePlay(i)"></audio>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.total_impression }} </span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.total_stream }} </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'
import 'flatpickr/dist/flatpickr.css'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
export default {
  /** Page Name */
  name: 'CreatorAnalytics',

  /** components */
  components: { flatPickr },

  /** data */
  data() {
    const startOfMonth = moment().startOf('month').format('DD-MM-YYYY') // First day of the month
    const today = moment().format('DD-MM-YYYY') // Today's date
    return {
      breadcrumb: [],
      length: 100,
      page: 1,
      module_name: 'Creator',
      total_impressions: 0,
      total_streams: 0,
      dateRange: `${startOfMonth} to ${today}`, // Automatically set to current month
      datePickerConfig: {
        wrap: true,
        mode: 'range', // Enables date range selection
        dateFormat: 'd-m-Y',
        maxDate: today, // Disable future dates
        defaultDate: [startOfMonth, today] // Pre-select this month's start date to today
      }
    }
  },

  /** computed */
  computed: {
    ...mapState('creator', ['createLoading', 'listLoading']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
    // ...mapState('creator', ['records', 'total', 'FilteredCount', 'listLoading'])
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('creator/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data
        /** breadcrumb implement  */
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Creator', url: '/creator/list' },
          { title: `${data.name} Analytics`, active: true }
        ]
      })
    }

    this.getAnalytics()
  },

  /** methods */
  methods: {
    ...mapActions('audio', {
      get: 'get'
    }),

    handlePlay(currentIndex) {
      if (this.$refs.audios) {
        // Convert $refs.audios to an array if it's not already
        const audios = Array.isArray(this.$refs.audios) ? this.$refs.audios : [this.$refs.audios]

        audios.forEach((audio, index) => {
          if (index !== currentIndex) {
            audio.pause()
          }
        })
      }
    },
    clearDateRange() {
      this.dateRange = null // Clear the dateRange value
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getAnalytics()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getAnalytics()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.getAnalytics()
    },

    /** navigate to list */
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'creator-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    async getAnalytics() {
      let start_date = null
      let end_date = null
      if (this.dateRange) {
        const dateRangeArray = this.dateRange.split(' to ')
        // Adjust parsing to match the new format 'DD-MM-YYYY'
        start_date = moment(dateRangeArray[0], 'DD-MM-YYYY').startOf('day').utc().format() // Set to start of day in UTC
        end_date = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').endOf('day').utc().format() // Set to end of day in UTC
          : moment(dateRangeArray[0], 'DD-MM-YYYY').endOf('day').utc().format()
      }

      const analyticsDetail = await this.$store.dispatch('creator/analytics', {
        id: this.$route.params.id,
        start_date,
        end_date,
        page: this.page,
        limit: this.length
      })
      const { data } = analyticsDetail.data
      const { audio_analytics, total_analytics } = data
      this.records = audio_analytics.results
      this.total = audio_analytics.totalResults
      this.FilteredCount = audio_analytics.totalResults
      this.total_impressions = total_analytics.total_impressions
      this.total_streams = total_analytics.total_streams
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    dateRange() {
      this.page = 1 // Reset to the first page when date range changes
      this.getAnalytics()
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-creator',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-creator > .con-vs-loading')
      }
    },
    page() {
      this.getAnalytics()
    }
  },
  mounted() {
    this.getAnalytics()
  }
}
</script>
<style lang="scss">
.input-group .feather-icon {
  position: absolute;
  top: 30px;
  right: 10%;
  transform: translateY(-50%);
  cursor: pointer;
}
#dateRange {
  width: 350px !important;
}
</style>
